<template>
    <div v-if="delay">
        <v-card elevation="0">
            <v-card-text>
                <v-row height="100%">
                    <v-col md="2">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="text-h6">
                                Student Finance Service
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                <br />
                                    <v-img src="../../../assets/backgrounds/kings_logo.jpg"></v-img>
                                <br />
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <v-list dense>
                            <v-list-item-group v-model="navigation">
                                <v-list-item
                                    v-for="item in items"
                                    :key="item.title"
                                    :color="item.color"
                                    :value="item.title"
                                >
                                    <v-list-item-icon>
                                        <v-icon :color="item.color">{{ item.icon }}</v-icon>
                                    </v-list-item-icon>
                                        <v-list-item-content>
                                        <v-list-item-title>
                                            {{ item.title }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                        <v-btn 
                            block
                            color="#B0BEC5"
                            v-if="!viewDisabled"
                            :disabled="hideViewDiabledbtn"
                            @click="showDisabledMenu()"
                        >
                            View Disabled Items
                        </v-btn>
                        <v-btn 
                            block
                            color="#B0BEC5"
                            v-if="viewDisabled"
                            @click="hideDisabledMenu()"
                        >
                            Hide Disabled Items
                        </v-btn>
                    </v-col>
                    <v-col md="10">
                        <StudentHome v-if="navigation == 'Home'"/>
                        <FeeStatement v-if="navigation == 'Fee Statement'"/>
                        <Netbill v-if="navigation == 'Net Bill'"/>
                        <T4A v-if="navigation == 'T4A'"/>
                        <T2202A v-if="navigation == 'T2202A'"/>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import auth from "../../../js/auth.js";
//Student Components
import StudentHome from "../../../views/Student/Home/Home.vue"
import FeeStatement from "../../../views/Student/Documents/FeeStatement.vue"
import Netbill from "../../../views/Student/Documents/NetBill.vue"
import T4A from "../../../views/Student/Documents/T4A.vue"
import T2202A from "../../../views/Student/Documents/T2202A.vue"

export default {
    components: {
        StudentHome,
        FeeStatement,
        Netbill,
        T4A,
        T2202A
    },
    props: {
        student: {
            required: true
        }
    },
    data(){
        return {
            delay: false,
            navigation: "Home",
            items: [
                { 
                  title: "Home", 
                  icon: "mdi-home",
                  color: "#BDBDBD"
                }
            ],
            viewDisabled: false,
            hideViewDiabledbtn: true
        }
    },
    methods: {
        setStudentSession(){
            const that = this;
            that.delay = false;

            sessionStorage.setItem("sfs_asss", JSON.stringify(that.student));

            that.delay = true;
        },
        getConfigResult(){
            const that = this;
            var config = auth.get_user().config;

            if(config.statement.match(/^Yes/i)){
                that.items.push(
                    { 
                    title: "Fee Statement", 
                    icon: "mdi-file-chart",
                    color: "#D1C4E9"
                    },
                )
            }

            if(config.netbill.match(/^Yes/i)){
                that.items.push(
                    { 
                    title: "Net Bill", 
                    icon: "mdi-file-table", 
                    color: "#80DEEA"
                    },
                )
            }

            if(config.t4a.match(/^Yes/i)){
                that.items.push(
                    { 
                    title: "T4A", 
                    icon: "mdi-file-export", 
                    color: "#A5D6A7"
                    }
                )
            }

            if(config.t2202a.match(/^Yes/i)){
                that.items.push(
                    { 
                    title: "T2202A", 
                    icon: "mdi-file-star", 
                    color: "#FFCC80"
                    }
                )
            }

            if(config.statement.match(/^Yes/i)&&config.netbill.match(/^Yes/i)&&config.t4a.match(/^Yes/i)&&config.t2202a.match(/^Yes/i)){
                that.hideViewDiabledbtn = true;
            }else {
                that.hideViewDiabledbtn = false;
            }
        },
        showDisabledMenu(){
            const that = this;

            var config = auth.get_user().config;

            if(config.statement.match(/^No/i)){
                that.items.push(
                    { 
                    title: "Fee Statement", 
                    icon: "mdi-file-chart",
                    color: "#BDBDBD"
                    },
                );
            }

            if(config.netbill.match(/^No/i)){
                that.items.push(
                    { 
                    title: "Net Bill", 
                    icon: "mdi-file-table", 
                    color: "#BDBDBD"
                    },
                );
            }

            if(config.t4a.match(/^No/i)){
                that.items.push(
                    { 
                    title: "T4A", 
                    icon: "mdi-file-export", 
                    color: "#BDBDBD"
                    }
                );
            }

            if(config.t2202a.match(/^No/i)){
                that.items.push(
                    { 
                    title: "T2202A", 
                    icon: "mdi-file-star", 
                    color: "#BDBDBD"
                    }
                );
            }

            that.viewDisabled = true;
        },
        hideDisabledMenu(){
            const that = this;

            that.items = [
                { 
                  title: "Home", 
                  icon: "mdi-home",
                  color: "#BDBDBD"
                }
            ];

            that.getConfigResult();

            that.viewDisabled = false;
        }
    },
    created(){
      const that = this;
      that.getConfigResult();
      that.setStudentSession();
    }
}
</script>